export default __webpack_public_path__ + "static/media/myTeamBanner-Mobile.56ad1511.png";